module.exports = __webpack_public_path__ + "img/angststoerungen1_1280.9b702165.webp";